import {
  FETCH_SERVICE_CENTER_FAILURE,
  FETCH_SERVICE_CENTER_SUCCESS,
  FETCH_SERVICE_CENTERS_BY_ORG_FAILURE,
  FETCH_SERVICE_CENTERS_BY_ORG_SUCCESS,
  FETCH_SERVICE_CENTERS_FAILURE,
  FETCH_SERVICE_CENTERS_SUCCESS,
  START_LOADING,
  STOP_LOADING,
} from "../actionConstants";

interface ServiceCenter {
  id: number;
  name: string;
  orgId: number;
  isDeleted: boolean;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  orgName?: string;
}

interface GlobalServiceCenterState {
  serviceCenters: ServiceCenter[];
  serviceCenter: ServiceCenter | null;
  loading: boolean;
  error: string | null;
}

const initialState: GlobalServiceCenterState = {
  serviceCenters: [],
  serviceCenter: null,
  loading: false,
  error: null,
};

export const globalServiceCenterReducer = (
  state = initialState,
  action: any
): GlobalServiceCenterState => {
  switch (action.type) {
    case FETCH_SERVICE_CENTERS_SUCCESS:
      return {
        ...state,
        serviceCenters: action.payload,
        loading: false,
        error: null,
      };
    case FETCH_SERVICE_CENTERS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case FETCH_SERVICE_CENTER_SUCCESS:
      return {
        ...state,
        serviceCenter: action.payload,
        loading: false,
        error: null,
      };
    case FETCH_SERVICE_CENTER_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case FETCH_SERVICE_CENTERS_BY_ORG_SUCCESS:
      return {
        ...state,
        serviceCenters: action.payload,
        loading: false,
        error: null,
      };
    case FETCH_SERVICE_CENTERS_BY_ORG_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case START_LOADING:
      return { ...state, loading: true };
    case STOP_LOADING:
      return { ...state, loading: false };
    default:
      return state;
  }
};
